module.exports = __webpack_public_path__ + "img/Faderen_Bilde-av-to-kvinner-som-tar-en-pause.0b4441ba.jpg";